import { buildApiUrl } from '../utils/apiSetup';
const authHeaders = (json = true) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem('access_token')}` };
  if (json) headers['Content-Type'] = 'application/json';
  return headers;
};

const parseError = async (response, fallback) => {
  try {
    const data = await response.json();
    if (typeof data.detail === 'string') return data.detail;
  } catch {
    /* ignore */
  }
  return fallback;
};

// Salary Components
export async function fetchSalaryComponents(signal) {
  const response = await fetch(buildApiUrl('/api/v1/payroll/salary-components'), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load salary components'));
  return response.json();
}

export async function createSalaryComponent(componentData, signal) {
  const response = await fetch(buildApiUrl('/api/v1/payroll/salary-components'), {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(componentData),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to create salary component'));
  return response.json();
}

export async function updateSalaryComponent(componentId, componentData, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/payroll/salary-components/${componentId}`), {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(componentData),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to update salary component'));
  return response.json();
}

export async function toggleSalaryComponentStatus(componentId, status, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/payroll/salary-components/${componentId}/status`), {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify({ status }),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to update salary component status'));
  return response.json();
}

// PF Rules
export async function fetchPFRules(signal, statusFilter = null, pfTypeFilter = null, pensionSchemeFilter = null) {
  let url = '/api/v1/payroll/pf-rules';
  const params = new URLSearchParams();
  if (statusFilter) params.append('status_filter', statusFilter);
  if (pfTypeFilter) params.append('pf_type_filter', pfTypeFilter);
  if (pensionSchemeFilter) params.append('pension_scheme_filter', pensionSchemeFilter);
  if (params.toString()) url += `?${params.toString()}`;
  
  const response = await fetch(buildApiUrl(url), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load PF rules'));
  return response.json();
}

export async function fetchPFRule(ruleId, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/payroll/pf-rules/${ruleId}`), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load PF rule'));
  return response.json();
}

export async function createPFRule(ruleData, signal) {
  const response = await fetch(buildApiUrl('/api/v1/payroll/pf-rules'), {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(ruleData),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to create PF rule'));
  return response.json();
}

export async function updatePFRule(ruleId, ruleData, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/payroll/pf-rules/${ruleId}`), {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(ruleData),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to update PF rule'));
  return response.json();
}

export async function deletePFRule(ruleId, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/payroll/pf-rules/${ruleId}`), {
    method: 'DELETE',
    headers: authHeaders(false),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to delete PF rule'));
  return null;
}

export async function togglePFRuleStatus(ruleId, status, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/payroll/pf-rules/${ruleId}/status`), {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify({ status }),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to update PF rule status'));
  return response.json();
}
